"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../../constants");

var icon_1 = require("../../../StoriesAPI/Story/utils/icon");

require("./style.scss");

var leftCornerClass = 'award-corner award-corner-left';
var rightCornerClass = 'award-corner award-corner-right';
var leftBottomCornerClass = 'award-corner award-corner-left-bottom';
var rightBottomCornerClass = 'award-corner award-corner-right-bottom';
/**
* Component to visualize an achievement.
*/

var AwardCertificate = function AwardCertificate(props) {
  var color = props.color,
      // eslint-disable-next-line @typescript-eslint/naming-convention
  conferred_by = props.conferred_by,
      description = props.description,
      icon = props.icon,
      label = props.label,
      name = props.name,
      style = props.style,
      subtitle = props.subtitle,
      year = props.year;
  var lightCornerStyle = {
    background: color.light
  };
  var darkCornerStyle = {
    background: color.dark
  };
  return react_1.default.createElement("div", {
    className: "story-award-certificate",
    style: style
  }, react_1.default.createElement("div", {
    className: rightCornerClass,
    style: lightCornerStyle
  }), react_1.default.createElement("div", {
    className: leftCornerClass,
    style: darkCornerStyle
  }), react_1.default.createElement("div", {
    className: leftBottomCornerClass,
    style: lightCornerStyle
  }), react_1.default.createElement("div", {
    className: rightBottomCornerClass,
    style: darkCornerStyle
  }), react_1.default.createElement("div", {
    className: "award-content"
  }, react_1.default.createElement("div", {
    className: "award-graphic",
    style: {
      borderColor: color.dark
    }
  }, react_1.default.createElement("span", {
    className: "award-icon"
  }, (0, icon_1.buildIcon)(icon))), year && react_1.default.createElement("div", {
    className: "award-pretitle",
    style: {
      color: color.dark
    }
  }, year), react_1.default.createElement("div", {
    className: "award-title",
    style: {
      color: color.light
    }
  }, label), react_1.default.createElement("div", {
    className: "award-subtitle"
  }, subtitle), react_1.default.createElement("div", {
    className: "award-name",
    style: {
      color: color.dark
    }
  }, name), react_1.default.createElement("div", {
    className: "award-description"
  }, description), conferred_by && react_1.default.createElement("div", null, react_1.default.createElement("div", {
    className: "award-organizer",
    style: {
      borderColor: color.dark
    }
  }, conferred_by.title), react_1.default.createElement("div", {
    className: "award-organizer-subtext"
  }, "Conferred By"))));
};

AwardCertificate.propTypes = {
  /** Colors to accent the `Certificate` */
  color: prop_types_1.default.shape({
    dark: prop_types_1.default.string.isRequired,
    light: prop_types_1.default.string.isRequired
  }).isRequired,

  /** Who the `Certificate` is presented by. */
  conferred_by: prop_types_1.default.shape({
    title: prop_types_1.default.string.isRequired
  }),

  /** Smallest text at the bottom of the `Certificate` */
  description: prop_types_1.default.string,

  /** Icon to display at the top of the `Certificate` */
  icon: prop_types_1.default.shape({
    name: prop_types_1.default.string.isRequired,
    source: prop_types_1.default.string.isRequired
  }),

  /** The title of the Award */
  label: prop_types_1.default.string,

  /** The awardee of the `Certificate` */
  name: prop_types_1.default.string.isRequired,

  /** Styling object of the `Certificate` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object,

  /** Text underneath the title of the `Certificate` */
  subtitle: prop_types_1.default.string,

  /** Largest text at the top of the `Certificate` */
  title: prop_types_1.default.string,

  /** When the `Certificate` was awarded. */
  year: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
AwardCertificate.defaultProps = {
  conferred_by: undefined,
  description: '',
  label: undefined,
  icon: {
    name: 'FaAward',
    source: constants_1.IconSource.FontAwesome
  },
  style: {},
  subtitle: undefined,
  title: undefined,
  year: undefined
};
exports.default = AwardCertificate;